import { Location, locationName } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const OnboardingPage = lazy(() => import('@cobliteam/onboarding'));

const routes = [
  {
    title: locationName[Location.ONBOARDING_SETUP],
    path: Location.ONBOARDING_SETUP,
    component: OnboardingPage,
  },
];

export default routes;
